import { useState, useEffect } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormSubsidiaryInvite, { FORM_SUBSIDIARY_INVITE_ID } from '../forms/FormSubsidiaryInvite';
import { useTranslation } from 'react-i18next';

export default function SheetSubsidiaryInvite({
    open,
    onOpenChange,
    subsidiary,
    onSubmit,
    isSubmitting,
    hasOwner = false,
    isSuperAdmin = false,
}) {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);

    useEffect(() => {
        if (open) {
            setResetKey((k) => k + 1);
        }
    }, [open]);

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0 gap-0"
                showCloseButton={false}
            >
                <SheetHeader className="p-5 border-b border-border flex-shrink-0">
                    <SheetTitle className="text-[18px] text-foreground">{t('subsidiary:inviterDesCollaborateurs')}</SheetTitle>
                    <p className="text-[13px] text-muted-foreground mt-1">
                        {t('subsidiary:invitezDesCollaborateursARejoindre')} {subsidiary?.name ?? t('subsidiary:ceSousCompte')}
                    </p>
                </SheetHeader>

                <FormSubsidiaryInvite
                    key={resetKey}
                    onSubmit={onSubmit}
                    hasOwner={hasOwner}
                    isSuperAdmin={isSuperAdmin}
                />

                <SheetFooter className="p-5 border-t border-border flex-shrink-0 flex gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        onClick={() => onOpenChange(false)}
                        className="flex-1 rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:annuler')}
                    </Button>
                    <SubmitButton
                        isSubmitting={isSubmitting}
                        loadingText={t('subsidiary:envoi')}
                        form={FORM_SUBSIDIARY_INVITE_ID}
                        className="flex-1 text-foreground rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:envoyerLesInvitations')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
